import moment from "moment"

export const formatDate = (dateString) => {
    if (dateString) {
        return moment(dateString).format('HH:mm DD/MM/YYYY')
    }
}

export const formatDate2 = (dateString) => {
    return moment(dateString).format('DD/MM/YYYY')
}

export const formatDateFromLocal = (dateString) => {
    return moment(dateString).format('YYYY-MM-DDTHH:mm:ssZ')
}

export const formatDateFromLocal2 = (dateString) => {
    return moment(dateString).format('YYYY-MM-DD HH:mm:ss')
}

export const formatDate3 = (dateString) => {
    return moment(dateString).format('YYYY-MM-DD')
}
